export default __webpack_public_path__ + "static/media/1.791cf0b4.jpg";